/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DatetimeInterval,
    DatetimeIntervalFromJSON,
    DatetimeIntervalFromJSONTyped,
    DatetimeIntervalToJSON,
} from './DatetimeInterval';

/**
 * 
 * @export
 * @interface LocalityWeatherRequestBody
 */
export interface LocalityWeatherRequestBody {
    /**
     * 
     * @type {Array<DatetimeInterval>}
     * @memberof LocalityWeatherRequestBody
     */
    intervals: Array<DatetimeInterval>;
}

export function LocalityWeatherRequestBodyFromJSON(json: any): LocalityWeatherRequestBody {
    return LocalityWeatherRequestBodyFromJSONTyped(json, false);
}

export function LocalityWeatherRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalityWeatherRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intervals': ((json['intervals'] as Array<any>).map(DatetimeIntervalFromJSON)),
    };
}

export function LocalityWeatherRequestBodyToJSON(value?: LocalityWeatherRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'intervals': ((value.intervals as Array<any>).map(DatetimeIntervalToJSON)),
    };
}

